var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center font-weight-bold primary--text my-2"},[_c('v-icon',{staticClass:"primary--text"},[_vm._v("\n    fas fa-shield-alt\n  ")]),_vm._v(" "),_c('span',{staticClass:"ma-1"},[_vm._v("\n      "+_vm._s(_vm.user.team.role_name)+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }